import { Fragment, useState } from "react";
import SkeletonOne from "../../skeleton/SkeletonOne";
import { useLocation, useNavigate } from "react-router-dom";
import { setGroupData } from "../../../redux/ApiSlice/Group/GroupSlice";
import { useDispatch } from "react-redux";

export function GroupsTab({ userId, groupList, loading }) {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const location = useLocation();
    const dispatch = useDispatch();

    const filterGroupData = Array.isArray(groupList) && groupList?.filter((item) =>
        item?.group_name.toLowerCase().includes(search.toLowerCase())
    );

    const handleNavigate = (groupId) => {
        const filterGroup = groupList?.find((group) => group.id === groupId);
        dispatch(setGroupData(filterGroup));
        navigate(`/group/${groupId}`, { state: { from: location.pathname } });
    };

    return (
        <Fragment>
            {!loading ? (
                <div className="overflow-scroll h-full no-scrollbar">
                    <div className="flex justify-between items-center mb-3 pb-1 px-2 border-b border-gray-200 dark:border-gray-800/50">
                        <p
                            onClick={() => navigate(`/createnewgroup`)}
                            className="text-[12px] text-light-blue-400 hover:text-light-blue-500 font-semibold cursor-pointer"
                        >
                            Create Group
                        </p>
                        {groupList?.length > 0 &&
                            <p className="text-[12px] text-black dark:text-white font-semibold">
                                {groupList?.length || 0} Groups
                            </p>
                        }
                    </div>
                    {groupList && groupList?.length > 0 ? filterGroupData?.map((sub) => (
                        <div
                            key={sub.id}
                            onClick={() => handleNavigate(sub.id)}
                            className="grid grid-cols-12 mb-3 pb-3 px-2 border-b border-gray-200 dark:border-gray-800/50"
                        >
                            <div className="col-span-2 h-10 w-10 flex justify-center items-center">
                                <img
                                    alt="avatar"
                                    src={sub.group_profile_picture}
                                    className="h-10 w-10 object-cover border border-gray-300 dark:border-gray-700 rounded-full cursor-pointer"
                                />
                            </div>
                            <div className="col-span-10 mt-[-3px]">
                                <p className="text-[12px] text-[#000] dark:text-white font-semibold cursor-pointer w-fit">
                                    {sub.group_name}
                                </p>
                                <p className="text-[10px] text-gray-600 dark:text-gray-600 line-clamp-1 cursor-pointer w-fit">
                                    {sub.description}
                                </p>
                                <div className="flex items-center mt-1">
                                    <p className="text-center text-[10px] flex item-center font-bold text-gray-500 dark:text-gray-700 cursor-pointer w-fit">
                                        {sub.member_count} Members
                                    </p>
                                </div>
                            </div>
                        </div>
                    )) :
                        <div className="flex justify-center items-center px-2">
                            <p className="text-[12px] mt-20 text-gray-600 dark:text-gray-500">
                                You have not joined or created a group yet.
                            </p>
                        </div>
                    }
                </div>
            ) :
                <SkeletonOne />
            }
        </Fragment>
    );
}